const lockerLocations = [
  {
    id: 'aeropuerto-cordoba',
    city_id: 'cordoba',
    search_code: 'COR',
    name: 'Aeropuerto Internacional de Córdoba',
    short_name: 'Aeropuerto COR',
    geometry: {
      location: {
        lat: -31.3155152,
        lng: -64.2136596,
      },
    },
  },
];

module.exports = { lockerLocations };
